/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const adminUpdateRating = /* GraphQL */ `
  mutation AdminUpdateRating(
    $id: String!
    $title: String
    $description: String
    $overall: Int
    $restaurantName: String
    $is_pini_adjacent: Boolean
  ) {
    adminUpdateRating(
      id: $id
      title: $title
      description: $description
      overall: $overall
      restaurantName: $restaurantName
      is_pini_adjacent: $is_pini_adjacent
    ) {
      success
      message
      __typename
    }
  }
`;
export const adminCreateUser = /* GraphQL */ `
  mutation AdminCreateUser(
    $username: String!
    $email: String!
    $password: String!
    $profilePictureBase64: String
    $profilePictureContentType: String
  ) {
    adminCreateUser(
      username: $username
      email: $email
      password: $password
      profilePictureBase64: $profilePictureBase64
      profilePictureContentType: $profilePictureContentType
    ) {
      success
      message
      __typename
    }
  }
`;
export const createBreakdownRating = /* GraphQL */ `
  mutation CreateBreakdownRating(
    $input: CreateBreakdownRatingInput!
    $condition: ModelBreakdownRatingConditionInput
  ) {
    createBreakdownRating(input: $input, condition: $condition) {
      id
      ratingID
      rating {
        id
        type
        title
        owner
        yelpBusinessId
        yelpBusinessName
        restaurantName
        imgKeys
        description
        overall
        is_pini_adjacent
        breakdownRatings {
          items {
            id
            ratingID
            name
            value
            notes
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        likes {
          items {
            id
            ratingID
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        comments {
          items {
            id
            ratingID
            content
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      name
      value
      notes
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateBreakdownRating = /* GraphQL */ `
  mutation UpdateBreakdownRating(
    $input: UpdateBreakdownRatingInput!
    $condition: ModelBreakdownRatingConditionInput
  ) {
    updateBreakdownRating(input: $input, condition: $condition) {
      id
      ratingID
      rating {
        id
        type
        title
        owner
        yelpBusinessId
        yelpBusinessName
        restaurantName
        imgKeys
        description
        overall
        is_pini_adjacent
        breakdownRatings {
          items {
            id
            ratingID
            name
            value
            notes
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        likes {
          items {
            id
            ratingID
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        comments {
          items {
            id
            ratingID
            content
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      name
      value
      notes
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteBreakdownRating = /* GraphQL */ `
  mutation DeleteBreakdownRating(
    $input: DeleteBreakdownRatingInput!
    $condition: ModelBreakdownRatingConditionInput
  ) {
    deleteBreakdownRating(input: $input, condition: $condition) {
      id
      ratingID
      rating {
        id
        type
        title
        owner
        yelpBusinessId
        yelpBusinessName
        restaurantName
        imgKeys
        description
        overall
        is_pini_adjacent
        breakdownRatings {
          items {
            id
            ratingID
            name
            value
            notes
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        likes {
          items {
            id
            ratingID
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        comments {
          items {
            id
            ratingID
            content
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      name
      value
      notes
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createRating = /* GraphQL */ `
  mutation CreateRating(
    $input: CreateRatingInput!
    $condition: ModelRatingConditionInput
  ) {
    createRating(input: $input, condition: $condition) {
      id
      type
      title
      owner
      yelpBusinessId
      yelpBusinessName
      restaurantName
      imgKeys
      description
      overall
      is_pini_adjacent
      breakdownRatings {
        items {
          id
          ratingID
          rating {
            id
            type
            title
            owner
            yelpBusinessId
            yelpBusinessName
            restaurantName
            imgKeys
            description
            overall
            is_pini_adjacent
            createdAt
            updatedAt
            __typename
          }
          name
          value
          notes
          createdAt
          updatedAt
          owner
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      likes {
        items {
          id
          ratingID
          rating {
            id
            type
            title
            owner
            yelpBusinessId
            yelpBusinessName
            restaurantName
            imgKeys
            description
            overall
            is_pini_adjacent
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          owner
          __typename
        }
        nextToken
        __typename
      }
      comments {
        items {
          id
          ratingID
          rating {
            id
            type
            title
            owner
            yelpBusinessId
            yelpBusinessName
            restaurantName
            imgKeys
            description
            overall
            is_pini_adjacent
            createdAt
            updatedAt
            __typename
          }
          content
          createdAt
          updatedAt
          owner
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const updateRating = /* GraphQL */ `
  mutation UpdateRating(
    $input: UpdateRatingInput!
    $condition: ModelRatingConditionInput
  ) {
    updateRating(input: $input, condition: $condition) {
      id
      type
      title
      owner
      yelpBusinessId
      yelpBusinessName
      restaurantName
      imgKeys
      description
      overall
      is_pini_adjacent
      breakdownRatings {
        items {
          id
          ratingID
          rating {
            id
            type
            title
            owner
            yelpBusinessId
            yelpBusinessName
            restaurantName
            imgKeys
            description
            overall
            is_pini_adjacent
            createdAt
            updatedAt
            __typename
          }
          name
          value
          notes
          createdAt
          updatedAt
          owner
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      likes {
        items {
          id
          ratingID
          rating {
            id
            type
            title
            owner
            yelpBusinessId
            yelpBusinessName
            restaurantName
            imgKeys
            description
            overall
            is_pini_adjacent
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          owner
          __typename
        }
        nextToken
        __typename
      }
      comments {
        items {
          id
          ratingID
          rating {
            id
            type
            title
            owner
            yelpBusinessId
            yelpBusinessName
            restaurantName
            imgKeys
            description
            overall
            is_pini_adjacent
            createdAt
            updatedAt
            __typename
          }
          content
          createdAt
          updatedAt
          owner
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const deleteRating = /* GraphQL */ `
  mutation DeleteRating(
    $input: DeleteRatingInput!
    $condition: ModelRatingConditionInput
  ) {
    deleteRating(input: $input, condition: $condition) {
      id
      type
      title
      owner
      yelpBusinessId
      yelpBusinessName
      restaurantName
      imgKeys
      description
      overall
      is_pini_adjacent
      breakdownRatings {
        items {
          id
          ratingID
          rating {
            id
            type
            title
            owner
            yelpBusinessId
            yelpBusinessName
            restaurantName
            imgKeys
            description
            overall
            is_pini_adjacent
            createdAt
            updatedAt
            __typename
          }
          name
          value
          notes
          createdAt
          updatedAt
          owner
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      likes {
        items {
          id
          ratingID
          rating {
            id
            type
            title
            owner
            yelpBusinessId
            yelpBusinessName
            restaurantName
            imgKeys
            description
            overall
            is_pini_adjacent
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          owner
          __typename
        }
        nextToken
        __typename
      }
      comments {
        items {
          id
          ratingID
          rating {
            id
            type
            title
            owner
            yelpBusinessId
            yelpBusinessName
            restaurantName
            imgKeys
            description
            overall
            is_pini_adjacent
            createdAt
            updatedAt
            __typename
          }
          content
          createdAt
          updatedAt
          owner
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const createLike = /* GraphQL */ `
  mutation CreateLike(
    $input: CreateLikeInput!
    $condition: ModelLikeConditionInput
  ) {
    createLike(input: $input, condition: $condition) {
      id
      ratingID
      rating {
        id
        type
        title
        owner
        yelpBusinessId
        yelpBusinessName
        restaurantName
        imgKeys
        description
        overall
        is_pini_adjacent
        breakdownRatings {
          items {
            id
            ratingID
            name
            value
            notes
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        likes {
          items {
            id
            ratingID
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        comments {
          items {
            id
            ratingID
            content
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateLike = /* GraphQL */ `
  mutation UpdateLike(
    $input: UpdateLikeInput!
    $condition: ModelLikeConditionInput
  ) {
    updateLike(input: $input, condition: $condition) {
      id
      ratingID
      rating {
        id
        type
        title
        owner
        yelpBusinessId
        yelpBusinessName
        restaurantName
        imgKeys
        description
        overall
        is_pini_adjacent
        breakdownRatings {
          items {
            id
            ratingID
            name
            value
            notes
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        likes {
          items {
            id
            ratingID
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        comments {
          items {
            id
            ratingID
            content
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteLike = /* GraphQL */ `
  mutation DeleteLike(
    $input: DeleteLikeInput!
    $condition: ModelLikeConditionInput
  ) {
    deleteLike(input: $input, condition: $condition) {
      id
      ratingID
      rating {
        id
        type
        title
        owner
        yelpBusinessId
        yelpBusinessName
        restaurantName
        imgKeys
        description
        overall
        is_pini_adjacent
        breakdownRatings {
          items {
            id
            ratingID
            name
            value
            notes
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        likes {
          items {
            id
            ratingID
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        comments {
          items {
            id
            ratingID
            content
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createComment = /* GraphQL */ `
  mutation CreateComment(
    $input: CreateCommentInput!
    $condition: ModelCommentConditionInput
  ) {
    createComment(input: $input, condition: $condition) {
      id
      ratingID
      rating {
        id
        type
        title
        owner
        yelpBusinessId
        yelpBusinessName
        restaurantName
        imgKeys
        description
        overall
        is_pini_adjacent
        breakdownRatings {
          items {
            id
            ratingID
            name
            value
            notes
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        likes {
          items {
            id
            ratingID
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        comments {
          items {
            id
            ratingID
            content
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      content
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateComment = /* GraphQL */ `
  mutation UpdateComment(
    $input: UpdateCommentInput!
    $condition: ModelCommentConditionInput
  ) {
    updateComment(input: $input, condition: $condition) {
      id
      ratingID
      rating {
        id
        type
        title
        owner
        yelpBusinessId
        yelpBusinessName
        restaurantName
        imgKeys
        description
        overall
        is_pini_adjacent
        breakdownRatings {
          items {
            id
            ratingID
            name
            value
            notes
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        likes {
          items {
            id
            ratingID
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        comments {
          items {
            id
            ratingID
            content
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      content
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteComment = /* GraphQL */ `
  mutation DeleteComment(
    $input: DeleteCommentInput!
    $condition: ModelCommentConditionInput
  ) {
    deleteComment(input: $input, condition: $condition) {
      id
      ratingID
      rating {
        id
        type
        title
        owner
        yelpBusinessId
        yelpBusinessName
        restaurantName
        imgKeys
        description
        overall
        is_pini_adjacent
        breakdownRatings {
          items {
            id
            ratingID
            name
            value
            notes
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        likes {
          items {
            id
            ratingID
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        comments {
          items {
            id
            ratingID
            content
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      content
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
